import React, { Component } from "react";
import { observer } from "mobx-react";
import { Web3Store } from "../stores/web3Store";
import border from "../images/avatar-border.png";
import iconMA from "../images/icons/ma.png";
import "../styles/onePage.less"
import NFTIPList from "../components/nftIPList";
import { CopyRightContent } from "../components/mintIPInforTabContents";
import { ILicensedNFT, IMythServerResponse, IPagination, IPRsp } from "../bean/ResponseBean";
import { Button, Tooltip, Collapse } from "antd";
import { CheckCircleFilled, LeftCircleOutlined, RightCircleOutlined } from "@ant-design/icons";
import { LicensedNFTStatus, MythServerResultCode } from "../constant/CommonConstant";
import logger from "../logger";
import { IGetDerivativeWorksForLicenseNFTRequest, } from "../bean/RequestBean";
import { withRouter } from "react-router-dom";
import { RouteComponentProps } from "react-router";
import { PageLoader } from "../components/pageLoader";
import MythImage from "../components/MythImage";
import { ArtistModal, LicensingNFTModal } from "../components/onePageModal";
import IPInfluenceList from "../components/iPInfluenceList";
import {getQueryString} from "../utils/commonUtils";

interface IProps extends RouteComponentProps {
    web3Store: Web3Store
}

interface IStates {
    ipId: number,
    ipList: IPRsp[],
    pageNum: number,
    totalPage: number,
    totalNum: number,
    licensedNFT: ILicensedNFT,
    loading: boolean,
    visibleLicense: boolean,
    visibleArtist: boolean
}

@observer
class OnePage extends Component<IProps, IStates> {
    constructor(props: IProps, state: IStates) {
        super(props);
        let ipId = 0;
        try{
            ipId = parseInt(getQueryString("ipId"));
        }catch (e) {
            console.log(e)
        }
        this.state = {
            ipId: ipId,
            ipList: [],
            pageNum: 1,
            totalPage: 1,
            totalNum: 0,
            licensedNFT: {
                ipId: 0,
                licensedNFTId: 0,
                licenseCollectionName: "",
                licenseCollectionAddress: "",
                licenseCollectionLogo: "",
                licenseCollectionBg: "",
                licensedNFTokenId: "",
                licensedNFTImage: "",
                licensedTime: "",
                licensedMethod: "",
                licensingPeriod: 0,
                totalSupply: 0,
                price: 0,
                status: 0,
                artistNum: 0
            },
            loading: true,
            visibleLicense: false,
            visibleArtist: false
        }
    }

    componentDidMount(): void {
        this.getLicensedNFT().then(value => {
            this.getIPsForLicensedNFT();
        });
    }

    getLicensedNFT = async () => {
        const { web3Store } = this.props;
        const { ipId } = this.state;
        try {
            if (web3Store.mythServerApi) {
                const result: IMythServerResponse<ILicensedNFT> = await web3Store.mythServerApi.getLicensedNFT(ipId);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.setState({
                            licensedNFT: data
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    getIPsForLicensedNFT = async () => {
        const { web3Store } = this.props;
        const { pageNum, licensedNFT } = this.state;
        try {
            if (web3Store.mythServerApi) {
                const request: IGetDerivativeWorksForLicenseNFTRequest = {
                    licensedNFTId: licensedNFT.licensedNFTId,
                    pageNum: pageNum,
                    pageSize: 8
                };
                const result: IMythServerResponse<IPagination<IPRsp>> = await web3Store.mythServerApi.getIPsForLicensedNFT(request);
                if (result.resultCode === MythServerResultCode.SUCCESS) {
                    const data = result.resultValue;
                    if (data) {
                        this.setState({
                            ipList: data.dataList,
                            totalNum: data.totalNum,
                            totalPage: data.totalPage,
                            loading: false
                        });
                    }
                }
            }
        } catch (e) {
            logger.error(e);
        }
    };

    showLicense = () => {
        this.setState({
            visibleLicense: true
        })
    };

    submitWork = () => {
        window.open('https://forms.gle/6TZZX1um1vWUgvo16');
    };

    hideLicense = () => {
        this.setState({
            visibleLicense: false
        })
    };

    showArtist = () => {
        // const {artistNum} = this.state.licensedNFT;
        // if (artistNum === 0) return false;
        // this.setState({
        //     visibleArtist: true
        // })
    };

    hideArtist = () => {
        // this.setState({
        //     visibleArtist: false
        // })
    };

    changePage = (num: number) => {
        const { pageNum, totalPage } = this.state;
        if (num < 0 && pageNum === 1) return false;
        else if (num > 0 && pageNum === totalPage) return false;
        else {
            this.setState({
                pageNum: pageNum + num
            }, () => {
                this.getIPsForLicensedNFT();
            })
        }
    };

    render() {
        const { ipList, totalPage, pageNum, totalNum, licensedNFT, loading, visibleLicense, visibleArtist } = this.state;
        const { web3Store } = this.props;
        const copyrightInfo = {
            licensedStatus: licensedNFT.status,
            licensedTime: licensedNFT.licensedTime,
            licensedWallet: licensedNFT.licenseCollectionAddress,
            collectionLogo: licensedNFT.licenseCollectionLogo,
            collectionName: licensedNFT.licenseCollectionName,
            licensedMode: licensedNFT.licensedMethod,
            nftImage: licensedNFT.licensedNFTImage,
            licensedNFTokenId: licensedNFT.licensedNFTokenId
        };
        const showNavigationIP = totalPage > 1 ? "block" : "none";
        const { Panel } = Collapse;
        return <div className="one-page">
            <img src={licensedNFT.licenseCollectionBg} alt="" className="one-page-banner" />
            <div className="one-page-section">
                <div className="user-info-container flex-row">
                    <div className="user-avatar">
                        <MythImage src={licensedNFT.licensedNFTImage} alt="" className="avatar-img" />
                        <img src={border} alt="" className="avatar-border" />
                    </div>
                    <div className="user-info">
                        <div>
                            <b className="user-name">{licensedNFT.licenseCollectionName} #{licensedNFT.licensedNFTokenId}</b>
                            {
                                licensedNFT.status === LicensedNFTStatus.UNLICENSED ?
                                    <Button className="myth-button btn-auth" onClick={this.showLicense}>License
                                        it</Button> :
                                    <Tooltip title="Licensed to SuperBrands">
                                        <span className="icon-container"><span className="light"></span><img src={iconMA} alt=""
                                            className="icon-ma" />
                                        </span>
                                    </Tooltip>
                            }
                        </div>
                        <div>
                            {/*                            {contributedArtists.slice(0, 3).map((item, i) => (
                                <Avatar src={item.artistAvatar} key={i} />
                            ))}
                            {contributedArtists.length > 3 && <Avatar style={{ backgroundColor: '#000' }} icon={<EllipsisOutlined />} />}*/}
                            <span className="contribute-text" onClick={this.showArtist}><b>{licensedNFT.artistNum}</b> artists contributed <i
                                className="iconfont icon-24gf-forward"></i></span>
                        </div>
                    </div>
                    <Button className="myth-button btn-work" onClick={this.submitWork}>Submit a work</Button>
                </div>
                <div className="tip-public">{licensedNFT.status === LicensedNFTStatus.UNLICENSED ? <CheckCircleFilled style={{ fontSize: "18px", color: "#999999" }} /> : <CheckCircleFilled style={{ fontSize: "18px", color: "#34c759" }} />} <span>Licensed to SuperBrands platform. Can be used freely for public display and derivative creation.</span>
                </div>
                <Collapse className="info-card" defaultActiveKey={['1']} expandIconPosition="end" ghost>
                    <Panel header={<span className="list-title">IP Licensing Info.</span>} key="1">
                        <CopyRightContent copyrightInfo={copyrightInfo} />
                    </Panel>
                </Collapse>
                <div className="work-list-title">
                    <span className="list-title">Works</span>
                    <span className="work-number">({totalNum})</span>
                </div>
                {loading ? <PageLoader></PageLoader> :
                    <div className="project-container">
                        <NFTIPList list={ipList} isOnePage={true} />
                        <LeftCircleOutlined className={`swiper-prev ${pageNum === 1 ? "disabled" : ""}`}
                            onClick={() => this.changePage(-1)} style={{ display: showNavigationIP }} />
                        <RightCircleOutlined className={`swiper-next ${pageNum === totalPage ? "disabled" : ""}`}
                            onClick={() => this.changePage(1)} style={{ display: showNavigationIP }} />
                    </div>
                }
                <div className="list-title">IP Influence</div>
                {licensedNFT.licensedNFTId > 0 && <IPInfluenceList web3Store={web3Store} licensedNFTId={licensedNFT.licensedNFTId} />}
            </div>
            {visibleLicense &&
                <LicensingNFTModal web3Store={web3Store} visible={visibleLicense} onCancel={this.hideLicense}
                    licensedNFT={licensedNFT} />}
            <ArtistModal visible={visibleArtist} onCancel={this.hideArtist} artistList={[1, 2]} />
        </div>
    }
}

export default withRouter(OnePage);
